if (!customElements.get('cart-added-notification')) {
  customElements.define('cart-added-notification', class CartAddedNotification extends HTMLElement {
    constructor() {
      super();
      this.closeButton = this.querySelector('.cart-added-notification__close');
      this.image = this.querySelector('.cart-added-notification__image');
      this.name = this.querySelector('.cart-added-notification__name');
      this.variants = this.querySelector('.cart-added-notification__variants');
      this.autoCloseTimeout = null;

      this.bindEvents();
    }

    bindEvents() {
      // Listen for custom event from product-form
      document.addEventListener('cart:product-added', this.show.bind(this));

      // Close button
      this.closeButton?.addEventListener('click', (e) => {
        e.preventDefault();
        this.hide();
      });

      // Click outside to close
      document.addEventListener('click', this.handleOutsideClick.bind(this));

      // Close on escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.hasAttribute('open')) {
          this.hide();
        }
      });
    }

    show(event) {
      const { title, image, variantOptions } = event.detail;

      // Populate content
      if (this.image) {
        this.image.src = image;
        this.image.alt = title;
      }
      if (this.name) {
        this.name.textContent = title;
      }
      if (this.variants) {
        this.variants.textContent = variantOptions.filter(Boolean).join(' | ');
      }

      // Show the notification
      this.setAttribute('open', '');

      // Trigger reflow for animation
      this.offsetHeight;

      // Add active class for slide-down animation
      requestAnimationFrame(() => {
        this.classList.add('active');
      });

      // Auto-close after 5 seconds
      this.resetAutoClose();
    }

    hide() {
      this.classList.remove('active');
      clearTimeout(this.autoCloseTimeout);

      // Wait for animation to complete then remove open attribute
      setTimeout(() => {
        this.removeAttribute('open');
      }, 300);
    }

    resetAutoClose() {
      clearTimeout(this.autoCloseTimeout);
      this.autoCloseTimeout = setTimeout(() => this.hide(), 5000);
    }

    handleOutsideClick(event) {
      if (this.hasAttribute('open') &&
          !this.contains(event.target) &&
          !event.target.closest('product-form')) {
        this.hide();
      }
    }
  });
}
